import {
  Hub as HubInterface,
  Client,
  Integration,
  IntegrationClass,
  Event,
} from "@jupiter/types";

let hub: Hub;

class Hub implements HubInterface {
  private _client?: Client;

  constructor(client?: Client) {
    this.bindClient(client);
  }

  getClient(): Client | undefined {
    return this._client;
  }

  public bindClient(client?: Client) {
    if (!client) return;
    this._client = client;
    client.setupIntegrations();
  }

  track(event: Event, otherProperties?: Record<string, any>) {
    return this._invokeClient("track", event, otherProperties);
  }

  public getIntegration<T extends Integration>(
    integration: IntegrationClass<T>
  ): T | null {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      return null;
    }
  }

  private _invokeClient<M extends keyof Client>(
    method: M,
    ...args: any[]
  ): any {
    const client = this._client;

    if (client && client[method]) {
      return (client as any)[method](...args);
    }

    return;
  }
}

export function getCurrentHub() {
  if (hub) return hub;
  hub = new Hub();
  return hub;
}
